import React from 'react';
import { func, string, number, bool, object, array } from 'prop-types';

import SinglePayElementAtTargetTable from '../../PayElementTables/PayElementAtTargetTable/SinglePayElementAtTargetTable';
import PayElementsAtTargetTable from '../../PayElementTables/PayElementAtTargetTable/PayElementsAtTargetTable';
import YearOverYearChart from '../../YearOverYearChart/YearOverYearChart';
import { surveyJobMatch as surveyJobMatchPropType } from '../../propTypes';

import './SurveyJobDrilldown.scss';

class SurveyJobDrilldown extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  static propTypes = {
    surveyJob: surveyJobMatchPropType,
    selectedPayElement: string,
    monetaryRounding: number,
    percentRounding: number,
    chartData: object,
    showAsPercentage: bool,
    toggleShowAsPercentage: func,
    showOverallComposites: bool,
    pricingData: array
  };

  render() {
    const {
      surveyJob,
      selectedPayElement,
      monetaryRounding,
      percentRounding,
      showAsPercentage,
      toggleShowAsPercentage,
      chartData,
      showOverallComposites,
      pricingData
    } = this.props;

    return (
      <div className="survey-job-drilldown">
        <SinglePayElementAtTargetTable
          pricingData={pricingData}
          data={surveyJob[selectedPayElement]}
          monetaryRounding={monetaryRounding}
          percentRounding={percentRounding}
        />
        <hr className="year-over-year__divider" />
        <YearOverYearChart
          className="survey-job-drilldown__chart"
          xAxisLabels={chartData.categories}
          seriesName={chartData.seriesName}
          seriesDataValues={chartData.data}
          showAsPercentage={showAsPercentage}
          toggleAction={toggleShowAsPercentage}
        />
        <PayElementsAtTargetTable
          data={surveyJob}
          monetaryRounding={monetaryRounding}
          percentRounding={percentRounding}
          showOverallComposites={showOverallComposites}
        />
      </div>
    );
  }
}

export default SurveyJobDrilldown;
